import { render, staticRenderFns } from "./EmployeeProficiencyParameterView.vue?vue&type=template&id=4e2ac050&"
import script from "./EmployeeProficiencyParameterView.vue?vue&type=script&lang=js&"
export * from "./EmployeeProficiencyParameterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports